<coin-v2-dialog-frame
  [header]="'cms.enlarged-image' | translate"
  (closeButtonClick)="close()">
  <div class="enlarge-img-container">
    <img
      aria-label="image"
      [src]="data.imageUrl" />
  </div>
</coin-v2-dialog-frame>
